// extracted by mini-css-extract-plugin
export default {"disclaimer__container":"InsuranceNotKnownDisclaimer_disclaimer__container__jJZqe","disclaimer__text":"InsuranceNotKnownDisclaimer_disclaimer__text__yzw79"};